










































































































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import AsesmenPopulasiKhususService from "@/services/AsesmenPopulasiKhusus";
import AsesmenPopulasiKhususStore from "@/store/modules/AsesmenPopulasiKhususStore";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import SeksiPenyakitForm from "./SeksiPenyakitForm.vue";
import SeksiPenyakitDetail from "./SeksiPenyakitDetail.vue";
import DetailRow from "./DetailRow.vue";

@Component({
  inject: {
    isReadOnly: { default: () => () => false }
  },
  components: {
    CardModalTtd,
    SeksiPenyakitForm,
    SeksiPenyakitDetail,
    DetailRow
  }
})
export default class CardAsesmenPopulasiKhusus extends Vue {
  @Prop() register!: number;
  @Prop() rm!: number;
  @Prop({ default: null }) value: any;

  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  valid = true;
  saving = false;
  editMode = false;
  editId: number | null = null;

  // Seksi flags
  seksiA = false;
  seksiB = false;
  seksiC = false;
  seksiD = false;

  // Examined at
  examinedAt = "";

  // Expansion panels
  openPanels: number[] = [];

  // Content data
  contentA = this.getDefaultContentA();
  contentB = this.getDefaultContentB();
  contentC = this.getDefaultContentC();
  contentD = this.getDefaultContentD();

  // TTD
  modalTtd = false;
  signRole = "";

  get anySeksiActive() {
    return this.seksiA || this.seksiB || this.seksiC || this.seksiD;
  }

  get isFullySigned() {
    return this.value && this.value.signed_perawat && this.value.signed_dpjp;
  }

  get canEdit() {
    return this.value && this.value.perawat_user_id === userModule.user.id;
  }

  get canSignPerawat() {
    return this.value && this.value.perawat_user_id === userModule.user.id && !userModule.isMedis;
  }

  get canSignDpjp() {
    return userModule.isMedis;
  }

  get canSignPpja() {
    // PPJA = perawat penanggung jawab asuhan: bukan dokter, berbeda dari perawat pelaksana
    return (
      this.value &&
      !userModule.isMedis &&
      this.value.perawat_user_id !== userModule.user.id
    );
  }

  get detailC() {
    return (this.value && this.value.content && this.value.content.seksi_c) || {};
  }

  get detailD() {
    return (this.value && this.value.content && this.value.content.seksi_d) || {};
  }

  getDefaultContentA() {
    return {
      tahu_penyakit: null,
      sumber_info: [],
      sumber_info_lainnya: null,
      info_jangka_waktu: null,
      jangka_waktu_satuan: null,
      pemeriksaan_rutin: null,
      pemeriksaan_rutin_tempat: null,
      penyakit_penyerta: null
    };
  }

  getDefaultContentB() {
    return {
      tahu_penyakit: null,
      sumber_info: [],
      sumber_info_lainnya: null,
      info_jangka_waktu: null,
      jangka_waktu_satuan: null,
      pemeriksaan_rutin: null,
      pemeriksaan_rutin_tempat: null,
      penyakit_penyerta: null
    };
  }

  getDefaultContentC() {
    return {
      riwayat_gangguan_jiwa: null,
      riwayat_pengobatan: null,
      keluarga_gangguan_jiwa: null,
      bisa_merawat_diri: null,
      bisa_berkomunikasi: null,
      bicara_dipahami: null,
      risiko_cedera_diri: null,
      risiko_cedera_orang_lain: null,
      risiko_bunuh_diri: null,
      memahami_instruksi: null,
      lainnya: null
    };
  }

  getDefaultContentD() {
    return {
      mengalami_kekerasan: null,
      jenis_kekerasan: [],
      jenis_kekerasan_lainnya: null,
      durasi_kekerasan: null,
      frekuensi_kekerasan: null,
      pelaku_kekerasan: null,
      perlu_pendampingan: null
    };
  }

  get sendData() {
    const content: any = {};
    if (this.seksiA) content.seksi_a = this.contentA;
    if (this.seksiB) content.seksi_b = this.contentB;
    if (this.seksiC) content.seksi_c = this.contentC;
    if (this.seksiD) content.seksi_d = this.contentD;

    // Format datetime
    const examinedAtFormatted = this.examinedAt
      ? this.examinedAt.replace("T", " ") + (this.examinedAt.length === 16 ? ":00" : "")
      : null;

    return {
      register_id: this.register,
      pasien_rm: this.rm,
      unit_id: userModule.user?.unit_id || "",
      seksi_a: this.seksiA,
      seksi_b: this.seksiB,
      seksi_c: this.seksiC,
      seksi_d: this.seksiD,
      content,
      examined_at: examinedAtFormatted
    };
  }

  async save() {
    if (this.readOnly) return;
    if (!(this.$refs.form as any).validate()) return;

    if (!this.anySeksiActive) {
      appModule.NoticeDelay("Minimal 1 seksi harus diaktifkan");
      return;
    }

    this.saving = true;
    try {
      if (this.editMode && this.editId) {
        await AsesmenPopulasiKhususService.update(this.editId, this.sendData);
        appModule.NoticeDelay("Berhasil mengupdate Asesmen Populasi Khusus");
      } else {
        await AsesmenPopulasiKhususService.create(this.sendData);
        appModule.NoticeDelay("Berhasil menyimpan Asesmen Populasi Khusus");
      }
      this.resetForm();
      this.$emit("saved");
    } catch (e) {
      // Error already handled by service
    } finally {
      this.saving = false;
    }
  }

  editData() {
    if (!this.value) return;

    this.editMode = true;
    this.editId = this.value.id;
    this.seksiA = this.value.seksi_a;
    this.seksiB = this.value.seksi_b;
    this.seksiC = this.value.seksi_c;
    this.seksiD = this.value.seksi_d;

    // Format for datetime-local input
    if (this.value.examined_at) {
      this.examinedAt = this.value.examined_at.substring(0, 16).replace(" ", "T");
    }

    const content = this.value.content || {};
    this.contentA = { ...this.getDefaultContentA(), ...(content.seksi_a || {}) };
    this.contentB = { ...this.getDefaultContentB(), ...(content.seksi_b || {}) };
    this.contentC = { ...this.getDefaultContentC(), ...(content.seksi_c || {}) };
    this.contentD = { ...this.getDefaultContentD(), ...(content.seksi_d || {}) };

    // Ensure arrays
    if (!Array.isArray(this.contentA.sumber_info)) this.contentA.sumber_info = [];
    if (!Array.isArray(this.contentB.sumber_info)) this.contentB.sumber_info = [];
    if (!Array.isArray(this.contentD.jenis_kekerasan)) this.contentD.jenis_kekerasan = [];

    // Clear store data so form mode shows
    AsesmenPopulasiKhususStore.SET_RECORD(null);
  }

  async deleteData() {
    if (!this.value) return;
    const confirmed = confirm("Apakah Anda yakin ingin menghapus Asesmen Populasi Khusus ini?");
    if (!confirmed) return;

    try {
      await AsesmenPopulasiKhususService.destroy(this.value.id);
      appModule.NoticeDelay("Berhasil menghapus Asesmen Populasi Khusus");
      this.$emit("saved");
    } catch (e) {
      // Error already handled
    }
  }

  printPdf() {
    if (!this.value) return;
    AsesmenPopulasiKhususService.print(this.value.id);
  }

  // TTD
  openTtd(role: string) {
    this.signRole = role;
    this.modalTtd = true;
  }

  async passTtd(password: string) {
    const signMap: any = {
      perawat: AsesmenPopulasiKhususService.signPerawat,
      dpjp: AsesmenPopulasiKhususService.signDpjp,
      ppja: AsesmenPopulasiKhususService.signPpja
    };
    const labelMap: any = { perawat: "Perawat", dpjp: "DPJP", ppja: "PPJA" };
    const signFn = signMap[this.signRole] || AsesmenPopulasiKhususService.signDpjp;

    try {
      const resp = await signFn(this.value.id, { password });

      if (resp.data.status == "1") {
        this.modalTtd = false;
        const label = labelMap[this.signRole] || "DPJP";
        appModule.NoticeDelay(`Berhasil Tanda Tangan ${label}`);
        appModule.addMsgTtd("");
        this.$emit("saved");
      } else {
        appModule.addMsgTtd(resp.data.message);
        this.modalTtd = true;
      }
    } catch (e) {
      this.modalTtd = true;
    }
  }

  resetForm() {
    this.editMode = false;
    this.editId = null;
    this.seksiA = false;
    this.seksiB = false;
    this.seksiC = false;
    this.seksiD = false;
    this.examinedAt = "";
    this.contentA = this.getDefaultContentA();
    this.contentB = this.getDefaultContentB();
    this.contentC = this.getDefaultContentC();
    this.contentD = this.getDefaultContentD();
    this.openPanels = [];
    if (this.$refs.form) {
      (this.$refs.form as any).resetValidation();
    }
  }
}
